import { Button } from "components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "components/ui/dialog";
import { CircleHelp } from "lucide-react";

import { useTranslation } from "react-i18next";
import { DialogConfirmProps } from "utils/enum/dialogConfirmProps";

interface DialogProps {
  dialogConfirmProps: DialogConfirmProps;
  setIsDialogOpen: (value: boolean) => void;
}

export function DialogConfirm({ dialogConfirmProps, setIsDialogOpen }: DialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={dialogConfirmProps.isOpen} onOpenChange={setIsDialogOpen}>
      <DialogContent className="max-w-md text-center pt-[50px]  ">
        {/* Warning Icon */}
        <CircleHelp className="mx-auto text-blue-700 w-[100px] h-[100px]" />
        {/* < /> */}
        <DialogHeader className=" flex items-center justify-center">
          <DialogTitle className="text-lg font-semibold ">
            <h1 className="text-[30px] font-semibold"> {dialogConfirmProps.title}</h1>
          </DialogTitle>
          <DialogDescription className=" text-muted-foreground text-md pt-3">{dialogConfirmProps.message}</DialogDescription>
          <div
            className="absolute flex items-center justify-center right-4 top-1 z-40  rounded-full bg-white dark:bg-[#020817] w-[28px] h-[28px]"
            // onClick={() => setIsDialogOpenEditProducts(false)}
          >
            {/* <X /> */}
          </div>
        </DialogHeader>
        <div className=" flex items-center justify-center gap-4 mt-[30px]">
          {/* Cancel Button */}
          <Button variant="outline" onClick={() => setIsDialogOpen(false)}>
            {t(`${dialogConfirmProps.titileButtonCancel}`)}
          </Button>

          {/* Confirm Delete Button */}
          <Button
            variant="destructive"
            onClick={() => {
              dialogConfirmProps.onSubmit(dialogConfirmProps.data);
              setIsDialogOpen(false);
            }}
          >
            {t(`${dialogConfirmProps.titileButtonSubmit}`)}
          </Button>
        </div>
        {/* <DialogFooter className="">
          
        </DialogFooter> */}
      </DialogContent>
    </Dialog>
  );
}

